import jsep from "jsep";

jsep.addBinaryOp("or", 1); // same as: "||"
jsep.addBinaryOp("and", 2); // same as: "&&"

/**
 * Evaluate a parsed JSEP expression to a boolean value.
 * @param anyParamValues current parameter and meta-parameter values
 * @param expression parsed expression to evaluate
 */
function evaluateToBoolean(anyParamValues: Record<string, unknown>, expression: jsep.Expression): boolean {
    let result: boolean;
    switch (expression.type) {
        case "Identifier":
            result = !!anyParamValues[(expression as jsep.Identifier).name];
            break;
        case "BinaryExpression": {
            const {operator, left, right} = expression as jsep.BinaryExpression;
            switch (operator) {
                case "and":
                case "&&":
                    result = evaluateToBoolean(anyParamValues, left) && evaluateToBoolean(anyParamValues, right);
                    break;
                case "or":
                case "||":
                    result = evaluateToBoolean(anyParamValues, left) || evaluateToBoolean(anyParamValues, right);
                    break;
                default:
                    throw new Error(`unsupported binary operator: ${operator}`);
            }
            break;
        }
        default:
            throw new Error(`unsupported operator or expression: ${expression.type}`);
    }
    return result;
}

/**
 * Check if a "dependsOn" expression evaluates to true, with the given map of current input values.
 * @param anyParamValues current parameter and meta-parameter values
 * @param dependsOnExpression expression to check
 * @return true, if the expression is either empty, or all requirement are fulfilled
 */
export function checkDependsOn(anyParamValues: Record<string, unknown>, dependsOnExpression: string): boolean {
    if (!dependsOnExpression) {
        return true;
    }
    try {
        const expression = jsep(dependsOnExpression);
        return evaluateToBoolean(anyParamValues, expression);
    } catch (e) {
        console.error(`Error checking dependency expression '${dependsOnExpression}'`, e);
        return false;
    }
}
